import * as types from './types';

const getContactValidation = () => ({
  type: types.GET_CONTACT_VALIDATION,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/userInfo/getContactData',
    method: 'GET'
  }
});

const updateContactValidation = userPhones => {
  return {
    type: types.UPDATE_CONTACT_VALIDATION,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: '/userInfo/updateContactData',
      method: 'PUT',
      body: userPhones
    }
  };
};

export { getContactValidation, updateContactValidation };
